import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon'

/**
 * Figma 4383:4107 — `lock-password-line` (padlock + three PIN dots).
 * Not available as a single MUI glyph; matches Remix / handoff asset.
 */
export function UnlockModalLockPasswordIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 11V7.5a4 4 0 0 1 8 0V11"
      />
      <rect
        x="5"
        y="11"
        width="14"
        height="11"
        rx="2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect x="8" y="15" width="2" height="2" rx="0.35" fill="currentColor" />
      <rect x="11" y="15" width="2" height="2" rx="0.35" fill="currentColor" />
      <rect x="14" y="15" width="2" height="2" rx="0.35" fill="currentColor" />
    </SvgIcon>
  )
}
